import React,{forwardRef} from "react"
import './Comingsoon.css';
import NavBar from "../components/coming-soon/nav-bar/NavBar";
import Section1 from '../components/coming-soon/sections/Section1'
import Section2 from '../components/coming-soon/sections/Section2'

import Slider from '../components/coming-soon/sections/Slider'

import Footer from "../components/coming-soon/Layout/footer/Footer";
export default function Comingsoon()
{

return(
    <div className="container-bg sliders">
      <div   className="h-100">
        <div id="animate-area">
        <div className="container">

<NavBar/>

<Section1/>
</div>
        </div>

</div>


    <div className="container">

<div className="slider-con" >
<Slider/>

</div>
<div style={{marginTop:'100px'}} className="footer"> 
<Section2/>

</div>
<div className="sticky-comingsoon d-flex flex-column">
        <a href="#" className="mt-3" >
        <img src="./assets/svgs/Facebook.svg" alt="Logo" className="social" />

        </a>

        <a href="#" className="mt-2" >
        <img src="./assets/svgs/Twitter.svg" alt="Logo" className="social"/>

        </a>

        <a href="#" className="mt-2">
        <img src="./assets/svgs/Instagram.svg" alt="Logo" className="social"/>

        </a>

        <a href="#" className="mt-2 mb-3">
        <img src="./assets/svgs/Linkedin.svg" alt="Logo" className="social"/>

        </a>

      </div>

    </div>

    <div className="space">

    </div>
    <Footer/>
    </div>

)
}